// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/shared/colors.css\"","ot_gray":"#888","ot_grayMidDk":"#666","newBucketContainer":"dndNewBucket__newBucketContainer___175DN print__printHidden___3GLMT","emptyBucket":"dndNewBucket__emptyBucket___1ls42","nav":"dndNewBucket__nav___1RsE1","list":"dndNewBucket__list___2ftSH","listItem":"dndNewBucket__listItem___3L0kZ","button":"dndNewBucket__button___3feAb"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/lib/tables/dnd/dndNewBucket.css
// module id = 1554
// module chunks = 0